import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { entitySearchStart, socketEntitySearchStart } from '../../actions'

const mapStateToProps = (state) => ({
    searchIndex: `search-collection-${state.getIn(['authorization', 'user', 'email'])}`,
    searching: state.getIn(['ui', 'entityStack', 'search', 'searching']),
    searchValue: state.getIn(['ui', 'entityStack', 'search', 'searchValue']),
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            entitySearchStart,
            socketEntitySearchStart,
        },
        dispatch
    )

export default (SearchBarComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnectSearchBar extends Component {
        static propTypes = {
            entitySearchStart: PropTypes.func.isRequired,
            searchIndex: PropTypes.string.isRequired,
            searching: PropTypes.bool.isRequired,
            searchValue: PropTypes.string.isRequired,
            socketEntitySearchStart: PropTypes.func.isRequired,
        }

        render() {
            return <SearchBarComponent {...this.props} />
        }
    }

    return HocConnectSearchBar
}
